import React from 'react';
import { dateObj, dateStr } from './globals';
import { Languages } from './languages';
import DatePicker, { registerLocale } from 'react-datepicker';
import it from "date-fns/locale/it";
import Autocomplete from 'react-autocomplete';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip as ChartTooltip,  ResponsiveContainer } from 'recharts';
import AddConfig from './addConfig';
import RemoveIcon from '../images/remove-icon-white.svg'
import Tooltip from 'react-tooltip-component-16';
import warningIcon from "../images/warning-icon.svg";
import errorIcon from "../images/error-icon.svg";
import okIcon from "../images/ok-icon.svg";
import { getPaginatedData, getVisiblePages } from "../helpers/helper"
import { evaluatePassword } from "../auth/passwordPolicy";

registerLocale("it", it);

export class PageTitle extends React.Component {
    constructor(props) {
        super(props);
        /* 
         * props => {
         *      icon,
         *      title,
         *      hideFaq
         *      
         *      children
         *  }
         */
    }

    onFaqClick() {
        window.open(Languages.getSection('Main').faqButtonUrl, '_blank');
    }

    render() {
        return <div className="page-title">
            <div className="page-title-icon" style={{ backgroundImage: 'url(' + this.props.icon + ')' }} />
            <div className="page-title-text">{this.props.title}</div>
            <div className="page-title-spacer"></div>
            {this.props.children}
            <div className="page-title-faq" onClick={this.onFaqClick} style={this.props.hideFaq ? { display: 'none' } : {}}></div>
        </div>;
    }
}
export class UserCard extends React.Component {
    constructor(props) {
        super(props);
        /*
         * props => {
         *      className
         *      handlers = { onEdit, onAddUser, onShowUsersList }
         *      logoutClick
         *  }
         */

        this.userData = JSON.parse(sessionStorage.getItem("userContext"));
        this.strings = Languages.getSection('UserProfile');
    }


    render() {
        let handlers = this.props.handlers;
        let {isSuperAdmin} = this.props.data;
        let editElement = handlers && handlers.onEdit ? <div className="text-center user-card-edit"><button className="wide" onClick={handlers.onEdit}>{this.strings.card.edit}</button></div> : [];
        let addUserElement = handlers && handlers.onAddUser ? <div className="widget-footer user-card-adduser" onClick={handlers.onAddUser}>{this.strings.addUser}</div> : [];
        let usersList = isSuperAdmin ? <div className="widget-footer user-card-usersList" onClick={handlers.onShowUsersList}>{this.strings.usersList.buttonText}</div>: null;

        let content = <div className="widget-content">
            <div className="widget-content-title user-card-title">{this.strings.card.title}</div>
            <div className="user-card-image"><div className="picture" style={{ backgroundImage: 'url(' + (this.userData.image || '../../images/user3x-d.png') + ')' }} /></div>
            <div className="text-center"><button className="thin" onClick={this.props.logoutClick}>{this.strings.card.logout}</button></div>
            <div className="user-card-name">{(this.userData.firstName + " " + this.userData.lastName)}</div>
            <div className="user-card-email">{this.userData.username}</div>
            {editElement}
        </div>;



        return (
            <div className="widget user-card">
                <div className="widget-header">&nbsp;</div>
                {content}
                {addUserElement}
                {usersList}
            </div>
        );
    }
}
export class ScrollableGridItem extends React.Component {
    constructor(props) {
        super(props);
        /*
         * props => {
         *      className
         *      icon
         *      title
         *      onClick
         *  }
         */
        this.clicked = this.clicked.bind(this);
    }
    
    clicked(ev) {
        if (this.props.onClick)
            this.props.onClick(ev, this.props.title, this.props.id);
    }

    render() {
        return <div className={"scrollable-grid-item " + (this.props.className || '')} onClick={this.clicked}>
            <div className="scrollable-grid-item-icon" style={{ backgroundImage: 'url(' + this.props.icon + ')'}}></div>
            <div className="scrollable-grid-item-title ellipsis">{this.props.title}</div>
        </div>;
    }
}
export class ScrollableGrid extends React.Component {
    constructor(props) {
        super(props);
        /*
         * props => {
         *      className
         *      byRows
         *      startAt first child to show 
         *      limit   number of children to show
         *  }
         */
    }

    render() {
        let first = this.props.startAt || 0;
        let limit = this.props.limit !== undefined ? this.props.limit : this.props.children.length;

        let visible = [];
        for (let i = first; i < first+limit && i < this.props.children.length; i++) {
            visible.push(this.props.children[i]);
        }

        return <div className={"scrollable-grid " + (this.props.className || '') + ' ' + (this.props.byRows ? 'rows' : '')}>
            <div className="horizontal-separator"></div>
            <div className={"scrollable-grid-content"}>
                {visible}
            </div>
            <div className="horizontal-separator"></div>
        </div>;
    }
}
export class ScrollableList extends React.Component {
    constructor(props) {
        super(props);
        /*
         * props => {
         *      className
         *  }
         */
    }

    render() {
        return <div className={"scrollable-list " + (this.props.className || '')}>
            <div className={"scrollable-list-content"}>
                {this.props.children}
            </div>
        </div>;
    }
}
export class UIPopup extends React.Component {
    constructor(props) {
        super(props);
        /*
         * props => {
         *      className
         *      title
         *      buttons
         *      onCancel
         *  }
         */
    }

    render() {
        return <div className={"popup " + (this.props.className || '')}>
            <div className="popup-content">
                <div className="popup-header">
                    <div className="popup-title">{this.props.title}</div>
                    <div className="popup-close" onClick={this.props.onCancel} style={{ display: this.props.onCancel ? 'block' : 'none' }}/>
                </div>

                <div className="popup-body">
                    {this.props.children}
                </div>

                <div className="popup-footer">
                    <UIButtonPad style={{ display: this.props.buttons && this.props.buttons.length > 0 ? 'block' : 'none' }}>
                        {this.props.buttons}
                    </UIButtonPad>
                </div>
            </div>
        </div>;
    }
}
export class UIButtonPad extends React.Component {
    constructor(props) {
        super(props);
        /*
         * className
         * align (center=default, left, right)
         */
    }
    

    render() {
        let align = this.props.align == 'left' ? 'left ' : (this.props.align == 'right' ? 'right ' : '');

        return <div className={"button-pad " + align + (this.props.className || '') }>
            {this.props.children}
        </div>;
    }
}
export class UICheckbox extends React.Component {
    constructor(props) {
        super(props);
        /*
         * disabled
         * name
         * value
         * label
         * onChange
         * error
         * mandatory
         */
        /*this.onChange = this.onChange.bind(this);
        this.state = {
            checked: (this.props.value && this.props.value != 0)//(this.props.value == 1 || this.props.value == 'true')
        };*/
    }
    /*
    onChange(ev) {
        ev.target.value = ev.target.checked ? 1 : '';
        this.setState({ checked: ev.target.checked });
        this.props.onChange(ev);
    }*/

    render() {
        let checked = (this.props.value && this.props.value != 0) ? true : false;
        if(this.props.disabled) {
            checked = false;
        }
        let value = checked ? 1 : 0;

        return <div className={"input-group " + (this.props.className || '')}>
            <div className={"input-element input-checkbox " + (this.props.mandatory ? 'mandatory ' : '')}>
                <div className={"input-field " + (this.props.error ? 'input-field-error' : '')}>
                    <input
                        key="fld"
                        id={this.props.name}
                        type="checkbox"
                        checked={checked}
                        value={value}
                        name={this.props.name || ''}
                        onChange={this.props.onChange}
                        disabled={this.props.disabled} />
                    <label key="lbl" className="input-label ellipsis" htmlFor={this.props.name || ''}>
                        {this.props.label}
                    </label>
                </div>
            </div>
        </div>
    }
}
export class UIButton extends React.Component {
    constructor(props) {
        super(props);
        /*
         * disabled
         * onClick
         * className
         * text
         * name
         * value
         * icon
         */ 
    }

    render() {
        let icon = this.props.icon ? <div className="button-icon" style={this.props.icon ? { backgroundImage: 'url(' + this.props.icon + ')' } : {}} /> : null;

        return <button
            type={this.props.type || "button"}
            disabled={this.props.disabled}
            className={(this.props.className || '') + (this.props.icon ? ' button-with-icon' : '')}
            name={this.props.name}
            value={this.props.value}            
            onClick={(ev) => this.props.onClick(ev)}>{icon}{this.props.text}</button>;
    }
}
export class UIInput extends React.Component {
    constructor(props) {
        super(props);
        /*
         * props => {
         *      type (text, ..., --  date, search)
         *      value,
         *      name
         *      className
         *      readOnly
         *      disabled
         *      hint
         *      label
         *      prefix = sublabel before input
         *      postfix = sublabel after input
         *      maxLength (default=50)
         *      error
         *      mandatory
         *      onChange
         *      onKeyUp
         *      onBlur
         *      
         *      -- opt if type == date
         *      maxDate
         *      minDate
         *  }
         */

    }

    render() {
        let type = this.props.type == 'search' ? 'text' : this.props.type;
        let hint = this.props.hint || (this.props.type == 'search' ? Languages.getSection('Main').searchLabel : '');

        if (/*type == 'date' && */(this.props.readOnly || this.props.disabled))
            type = 'text';

        let field = null;
        if (type == 'date') {
            field = <DatePicker
                key="field" 
                maxDate={this.props.maxDate}
                minDate={this.props.minDate}
                dateFormat="dd/MM/yyyy"
                closeOnScroll={true}
                name={this.props.name || ''}
                placeholderText={this.props.hint}
                locale={Languages.selectedLanguage}
                selected={dateObj(this.props.value)}
                onKeyUp={this.props.onKeyUp}
                autoComplete="off"
                onChange={(date) => { this.props.onChange({ target: { name: this.props.name || '', value: dateStr(date) } }) }}
                onBlur={this.props.onBlur}
                maxLength={10} />;
        }
        else {
            field = <input
                key="field" 
                type={type || "text"}
                id={`input-label ${this.props.name}`}
                value={this.props.value || ''}
                name={this.props.name || ''}
                placeholder={this.props.hint}
                onChange={this.props.onChange}
                onKeyUp={this.props.onKeyUp}
                onBlur={this.props.onBlur}
                disabled={this.props.readOnly || this.props.disabled}
                maxLength={this.props.maxLength || 50} />;
        }

        let cols = 'auto ' + (this.props.prefix ? 'auto ' : '') + (this.props.postfix ? 'auto ' : '');

        return <div className={"input-group " + (this.props.className || '') + (this.props.disabled || this.props.readonly ? ' disabled' : '')}>
            <div className={"input-element " + (this.props.mandatory ? 'mandatory ' : '') + (this.props.type || 'text')}>
                <label className="input-label ellipsis" htmlFor={`input-label ${this.props.name}`}>
                    {this.props.label}
                </label>
                <div className="input-row" style={{gridTemplateColumns: cols}}>
                    {this.props.prefix ? <label key="prefix" className="input-prefix">{this.props.prefix}</label> : ''}
                    <div className={"input-field " + (this.props.error ? 'input-field-error' : '')}>
                        {field}
                    </div>
                    {this.props.postfix ? <label key="postfix" className="input-postfix">{this.props.postfix}</label> : ''}
                </div>
            </div>
        </div>
    }
}
export class UIAutocomplete extends React.Component {
    constructor(props) {
        super(props);
        this.autocompleteChange = this.autocompleteChange.bind(this);
        this.autocompleteSelected = this.autocompleteSelected.bind(this);
        this.autocompleteCountryChange = this.autocompleteCountryChange.bind(this)
        this.autocompleteCountrySelected = this.autocompleteCountrySelected.bind(this);
    }

    autocompleteChange(ev) {
        this.props.onAutocompleteCityChange(ev, this.props.orderIndex, this.props.name, ev.target.value, this.props.source);
    }

    autocompleteSelected(value, items) {
        this.props.onAutocompleteCitySelected(this.props.orderIndex, this.props.name, value, items, this.props.source);
    }
    
    autocompleteCountrySelected(items) {
        this.props.onAutocompleteCountrySelected(this.props.orderIndex, this.props.name, items.label, items.code);
    }
                        
    autocompleteCountryChange(ev) {
        if (this.props.onAutocompleteCountryChange) {
            this.props.onAutocompleteCountryChange(ev, this.props.orderIndex, this.props.name, ev.target.value);
        }
    }

    render() {
        let type = this.props.type == 'autocomplete' ? 'text' : this.props.type;
        let field = null;
        
        if(this.props.type === 'autocomplete') {
            field = (<Autocomplete
                        getItemValue={(item) => item.label}
                        items={this.props.options}
                        renderMenu={children => (
                            <div className="autocomplete-menu menu-city">
                                {children}
                            </div>
                        )}
                        renderItem={(item, isHighlighted) =>
                            <div key={item.label} className={"item " + (isHighlighted ? 'hilighted' : '')}>
                                {item.label}
                            </div>
                        }
                        value={this.props.value}
                        onChange={this.autocompleteChange}
                        onSelect={(val, items) => this.autocompleteSelected(val, items)}
                    />);

        } else if(type === 'autocomplete-country') {
            field = (<Autocomplete
                        getItemValue={(item) => item.label}
                        items={this.props.options}
                        renderMenu={children => (
                            <div className="autocomplete-menu menu-country">
                                {children}
                            </div>
                        )}
                        renderItem={(item, isHighlighted) =>
                            <div key={item.label} className={"item " + (isHighlighted ? 'hilighted' : '')}>
                                {item.label}
                            </div>
                        }
                        name={this.props.name}
                        value={this.props.value}
                        onChange={this.autocompleteCountryChange}
                        onSelect={(val, items) => this.autocompleteCountrySelected(items)}
                    />);
        }
        

        let cols = 'auto ' + (this.props.prefix ? 'auto ' : '') + (this.props.postfix ? 'auto ' : '');

        return <div className={"input-group " + (this.props.className || '') + (this.props.disabled || this.props.readonly ? ' disabled' : '')}>
            <div className={"input-element " + (this.props.mandatory ? 'mandatory ' : '') + (this.props.type || 'text')}>
                <div className="input-label ellipsis">
                    {this.props.label}
                </div>
                <div className="input-row" style={{gridTemplateColumns: cols}}>
                    {this.props.prefix ? <label key="prefix" className="input-prefix">{this.props.prefix}</label> : ''}
                    <div className={"input-field " + (this.props.error ? 'input-field-error' : '')}>
                        {field}
                    </div>
                    {this.props.postfix ? <label key="postfix" className="input-postfix">{this.props.postfix}</label> : ''}
                </div>
            </div>
        </div>
    }
}
export class UIMultiSelect extends React.Component {
    constructor(props) {
        super(props);
        /*
         * props => {
         *      value,
         *      name
         *      onChange
         *      className
         *      readOnly
         *      disabled
         *      hint
         *      label
         *      options = [{ value,columns[] }] 
         *      error
         *      mandatory
         *  }
         */
        //let val = this.props.value ? (Array.isArray(this.props.value) ? this.props.value : this.props.value.split(',')) : [];
        this.state = {
            //value: val,
            expanded: false
        };

        this.inputRef = React.createRef();
        this.onChange = this.onChange.bind(this);
        this.toggleOptions = this.toggleOptions.bind(this);
    }

    componentDidUpdate() {
        if (this.state.expanded && (!this.props.options || this.props.options.length == 0))
            this.toggleOptions(false);
    }

    setInputValue(node, inputValue){
        const descriptor = Object.getOwnPropertyDescriptor(node, 'value');

        node.value = `${inputValue}#`;
        if (descriptor && descriptor.configurable) {
            delete node.value;
        }
        node.value = inputValue;

        const e = document.createEvent('HTMLEvents');
        e.initEvent('change', true, false);
        node.dispatchEvent(e);

        if (descriptor) {
            Object.defineProperty(node, 'value', descriptor);
        }
    };

    onChange(ev) {
        let name = ev.target.name;
        let value = ev.target.value;
        let val = this.props.value; //JSON.parse(JSON.stringify(this.props.value));
        if (ev.target.checked) {
            val.push(value);
        }
        else {
            let i = val.indexOf(value);
            if (i >= 0)
                val.splice(i, 1);
        }
        //this.setState({ value: val });
        this.setInputValue(this.input, val);
    }

    toggleOptions(bstate) {
        if (!this.props.disabled)
            this.setState({ expanded: (bstate != null) ? bstate : !this.state.expanded });
        else
            this.setState({ expanded: false });
    }


    render() {
        let head = this.props.headers ? <thead><tr><th></th>{this.props.headers.map((el, idx) => (<th key={idx}>{el}</th>))}</tr></thead> : [];
        let body = this.props.options ?
            <tbody>
                {
                    this.props.options.map((el, idx) => {
                        if (!el.columns)
                            el.columns = [];
                        else if (!Array.isArray(el.columns))
                            el.columns = [el.columns];

                        return <tr key={idx}>
                            <td key={0}><input type="checkbox" disabled={this.props.readOnly || this.props.disabled} value={el.value} onChange={this.onChange} checked={this.props.value.indexOf(el.value) >= 0} /></td>
                            {el.columns.map((it, iidx) => (<td className={iidx > 0 ? "subs" : ""} key={iidx + 1}>{it}</td>))}
                        </tr>
                    })
                }
            </tbody> : [];


        return <div className={"input-group " + (this.props.className || '')}>

            <div className={"input-element select " + (this.props.mandatory ? 'mandatory ' : '')}>
                <div className="input-label ellipsis">
                    {this.props.label}
                </div>
                <div className={"input-field " + (this.props.error ? 'input-field-error' : '')}>

                    <input type="text"
                        value={this.props.value || ''}
                        name={this.props.name || ''}
                        readOnly={true}
                        placeholder={this.props.hint}
                        // value={this.props.value}
                        onChange={this.props.onChange}
                        ref={myinput => (this.input = myinput)}
                        onClick={(ev) => this.toggleOptions()}/>

                    <div className="multiselect-content" style={{ display: this.state.expanded ? 'block' : 'none' }}>
                        <div className="multiselect-close" onClick={(ev) => this.toggleOptions()} />
                        <table>
                            {head}
                            {body}
                        </table>
                    </div>
                </div>
            </div>
        </div>
    }
}
export class UISelect extends React.Component {
    constructor(props) {
        super(props);
        /*
         * props => {
         *      value,
         *      name
         *      onChange
         *      className
         *      readOnly
         *      disabled
         *      hint
         *      label
         *      options = [{value,text}] -- can also be passed as children 
         *      error
         *      mandatory
         *  }
         */
        this.onChange = this.onChange.bind(this);
    }

    onChange(ev) {
        this.props.onChange(ev);
    }

    render() {
        let options = this.props.options
            ? this.props.options.map(el => {
                return <option key={el.value} value={el.value}>{el.text}</option>;
            })
            : [];

        return <div className={"input-group " + (this.props.className || '')}>
            <div className={"input-element select " + (this.props.mandatory ? 'mandatory ' : '')}>
                {this.props.label && <div className="input-label ellipsis">
                    {this.props.label}
                </div>}
                <div className={"input-field " + (this.props.error ? 'input-field-error' : '')}>
                    <select
                        value={this.props.value || ''}
                        name={this.props.name || ''}
                        onChange={this.props.onChange}
                        disabled={this.props.disabled || this.props.readOnly}>
                        {this.props.children}
                        {options}
                    </select>
                </div>
            </div>
        </div>
    }
}
export class SelectField extends React.Component {
    constructor(props) {
        super(props);
        /*
         * props => {
         *      value,
         *      name
         *      onChange
         *      className
         *      readOnly
         *      disabled
         *      hint
         *      label
         *      options = [{value,text}] -- can also be passed as children 
         *      error
         *      mandatory
         *  }
         */
        this.onSelectFieldChange = this.onSelectFieldChange.bind(this);
    }

    onSelectFieldChange(e) {
        const isCountryEu = e.target.selectedOptions[0].getAttribute('data-is-country-eu');
        if(isCountryEu) {
            const countryName = e.target.value;
            const countryCode = e.target.selectedOptions[0].getAttribute('data-countrycode');
            const isVisibleExtraEu = e.target.selectedOptions[0].getAttribute('data-is-visible-extra-eu')
            this.props.onSelectChange(e, this.props.orderIndex, this.props.name, countryName, countryCode, this.props.source, JSON.parse(isCountryEu), JSON.parse(isVisibleExtraEu));
        } else {
            this.props.onSelectChange(e, this.props.orderIndex, this.props.name);
        }

    }

    render() {
        let options = this.props.options
            ? this.props.options.map(el => {
                return <option 
                        data-is-country-eu = {el.eu}
                        data-idcountry = {el.idcountry} 
                        data-countrycode={el.code} key={el.idcountry}
                        data-is-visible-extra-eu = {el.is_visible_extra_eu}
                        value={el.name}>{el.name}
                    </option>;
            })
            : [];

        return <div className={"input-group " + (this.props.className || '')}>
            <div className={"input-element select " + (this.props.mandatory ? 'mandatory ' : '')}>
                {this.props.label && <div className="input-label ellipsis">
                    {this.props.label}
                </div>}
                <div className={ this.props.hasDefaultClass === false ? "": "input-field " + (this.props.error ? 'input-field-error' : '')}>
                    <select
                        value={this.props.value || ''}
                        name={this.props.name || ''}
                        onChange={this.onSelectFieldChange}
                        disabled={this.props.disabled || this.props.readOnly}>
                        {this.props.children}
                        {options}
                    </select>
                </div>
            </div>
        </div>
    }
}
export class UIRadioGroup extends React.Component {
    handleChange = (e) => {
        const { onChange } = this.props;
        onChange(e.target.value);
    };

    render() {
        const { name, options, selectedValue, required } = this.props;
        return (
            <div className="radio-box">
                {options.map(option => (
                    <label key={option.id} className="switch">
                        <input
                            type="radio"
                            name={name}
                            value={option.value}
                            
                            onChange={this.handleChange}
                            required={required}
                        />
                        <span className="slider"></span>
                        {option.label}
                    </label>
                ))}
            </div>
        )
    }
}
export class UIRadioSwitch extends React.Component {
    handleChange = () => {
        const {
            value,
            leftValue,
            rightValue,
            onChange
        } = this.props;

        const isRightSelected =
            value === rightValue;

        const nextChecked =
            !isRightSelected;

        const selectedValue =
            nextChecked
                ? rightValue
                : leftValue;

        if (onChange) {
            onChange(
                selectedValue,
                nextChecked
            );
        }
    };

    render() {
        const {
            leftLabel,
            rightLabel,
            leftValue,
            rightValue,
            value,
            disabled
        } = this.props;

        const checked =
            value === rightValue;

        return (
            <div>
                <div
                    className={`toggle-switch ${disabled
                            ? "toggle-switch-disabled"
                            : ""
                        }`}
                >
                    <span
                        className={
                            checked
                                ? "toggle-switch-label"
                                : "toggle-switch-label toggle-switch-label-active"
                        }
                    >
                        {leftLabel}
                    </span>

                    <button
                        type="button"
                        className={`toggle-switch-control ${checked
                                ? "toggle-switch-control-checked"
                                : ""
                            }`}
                        onClick={this.handleChange}
                        disabled={disabled}
                        aria-pressed={checked}
                    >
                        <span className="toggle-switch-thumb" />
                    </button>

                    <span
                        className={
                            checked
                                ? "toggle-switch-label toggle-switch-label-active"
                                : "toggle-switch-label"
                        }
                    >
                        {rightLabel}
                    </span>
                </div>
            </div>
        );
    }
}
export class UIMessageBox extends React.Component {
    constructor(props) {
        super(props);
        /*
         * props => {
         *      type
         *      title
         *      message,
         *      icon
         *      className
         *  }
         *  
         *  childen as buttons
         */
    }

    render() {
        let type = this.props.type || 'info';
        let icon = this.props.icon;
        if (!icon) {
            switch (type) {
                case 'info':
                    icon = '';
                    break;
                case 'warning':
                    icon = '';
                    break;
                case 'error':
                    icon = '';
                    break;
                case 'question':
                    icon = '';
                    break;
            }
        }
        let message = Array.isArray(this.props.message)
            ? this.props.message.map((msg, idx) => (<div  key={idx}>{msg}</div>))
            : <div key="0">{this.props.message}&nbsp;</div>;
        return <UIPopup className={"message-box " + type + " " + this.props.className || ''} title={this.props.title} buttons={this.props.children}>
            <div className="message-box-content">
                <div className="message-box-icon " style={{ backgroundImage: 'url(' + icon + ')', display: icon ? "block" : 'none' }}>
                </div>
                <div className="message-box-text ">
                    {message}
                </div>
            </div>
        </UIPopup>;
    }
}
export class UISummary extends React.Component {
    constructor(props) {
        super(props);
        /*
         * props => {
         *      className
         *      children = [UISummary]
         *  }
         */
    }

    render() {
        let title = this.props.title
            ? <div>{this.props.title}</div>
            : null;

        return <div className={"page-summary " + (this.props.className || '')}>
            {title}
            {this.props.children}
        </div>;
    }
}
export class UISummaryWidgetBar extends React.Component {
    constructor(props) {
        super(props);
        /*
         * props => {
         *      className
         *      children = [UISummaryWidget]
         *  }
         */
    }

    render() {
        return <div className={"page-summary-widget-bar " + (this.props.className || '')}>
            {this.props.children}
        </div>;
    }
}
export class UISummaryWidget extends React.Component {
    constructor(props) {
        super(props);
        /*
         * props => {
         *      title
         *      className
         *      hint
         *      mainLabel
         *      mainScore
         *      subLabel
         *      subScore
         *  }
         */
    }

    render() {
        let label1 = this.props.mainLabel == null ? Languages.getSection('Main').summary.row1 : this.props.mainLabel;
        let label2 = this.props.subLabel == null ? Languages.getSection('Main').summary.row2 : this.props.subLabel;

        return <UISummaryEmptyWidget title={this.props.title} className={this.props.className} hint={this.props.hint}>
            <div className="page-summary-title">{label1}</div>
            <div className="page-summary-score main-score">{this.props.mainScore || 0}</div>
            <div className="page-summary-separator" />
            <div className="page-summary-title">{label2}</div>
            <div className="page-summary-score">{this.props.subScore || 0}</div>
        </UISummaryEmptyWidget>
        /*return <div className={"widget " + (this.props.className || '')} title={this.props.hint}>
            {this.props.title ? <div className="widget-header">{this.props.title}</div> : <div />}
            <div className="widget-content">
                <div className="page-summary-title">{label1}</div>
                <div className="page-summary-score main-score">{this.props.mainScore || 0}</div>
                <div className="page-summary-separator"/>
                <div className="page-summary-title">{label2}</div>
                <div className="page-summary-score">{this.props.subScore || 0}</div>
            </div>
        </div>;*/
    }
}
export class UISummaryEmptyWidget extends React.Component {
    constructor(props) {
        super(props);
        /*
         * props => {
         *      title
         *      hint
         *      className
         *      
         *      children
         *  }
         */
    }

    render() {
        return <div className={"widget " + (this.props.className || '')} title={this.props.hint}>
            {this.props.title ? <div className="widget-header">{this.props.title}</div> : <div />}
            <div className="widget-content">
                {this.props.children}
            </div>
        </div>;
    }
}
export class UIFilterPanel extends React.Component {
    constructor(props) {
        super(props);
        /*
         * props => {
         *      title
         *      className
         *      
         *      content as children
         *  }
         */
    }
    render() {
        const children = React.Children.toArray(this.props.children);

        let hasFilters = false;

        let fields = children.map((el, idx) => {
            let item = (
                <div key={'row' + idx} className="page-filter-panel-item">
                    {el}
                </div>
            );

            if (
                el.type?.name === UIInput.name ||
                el.type?.name === UISelect.name ||
                el.type?.name === UIInputGroup.name
            ) {
                hasFilters = true;
            }

            return item;
        });

        return (
            <div className={"page-filter-panel" + (this.props.className || '')}>
                <div
                    key="title"
                    style={hasFilters && this.props.showTitle !== false ? {} : { display: 'none' }}
                    className="page-filter-panel-title"
                >
                    <div>{Languages.getSection('Main').filterBy}</div>
                </div>

                {fields}

                {this.props.onAdvancedToggle && (
                    <>
                        <div className="filter-panel-line-break"></div>

                        <UIAdvancedFilters
                            open={this.props.advancedOpen}
                            onToggle={this.props.onAdvancedToggle}
                        >
                            {this.props.advancedContent}
                        </UIAdvancedFilters>
                    </>
                )}
            </div>
        );
    }
}
export class UIAdvancedFilters extends React.Component {
    constructor(props) {
        super(props);
        this.le = Languages.Components.UIAdvancedFilters[Languages.selectedLanguage];
    }
    render() {
        return (
            <div className="advanced-filters-row">
                <div className="page-filter-panel-title advanced-filter-title">
                    <button
                        type="button"
                        className="advanced-filter-text-button"
                        onClick={this.props.onToggle}
                    >
                        {this.le.AdvancedFilterTitle}
                        <span className={`advanced-filter-icon ${this.props.open ? "open" : ""}`}>
                            <i className="fa-solid fa-angle-right"></i>
                        </span>
                    </button>
                </div>

                {this.props.open && (
                    <div className="advanced-filters-content">
                        {this.props.children}
                    </div>
                )}
            </div>
        );
    }
}
export class UIDownload extends React.Component {
    constructor(props) {
        super(props);
        /*
         * props => {
         *      onClick
         *      title
         *      icon
         *      className
         *  }
         *  
         *  childen as buttons
         */
    }

    render() {
        return <div className={"file-transfer download" + (this.props.className || '')}>
            <div className="file-transfer-icon" style={ this.props.icon ? { backgroundImage: 'url(' + this.props.icon + ')' } : null}></div>
            <div><UIButton className="modify" text={this.props.title} onClick={this.props.onClick}/></div>
        </div>;
    }
}
export class UIUpload extends React.Component {
    constructor(props) {
        super(props);
        /*
         * props => {
         *      onChange
         *      title
         *      icon
         *      className
         *      style
         *  }
         *  
         *  childen as buttons
         */
        this.inputRef = React.createRef();
        this.onChangeHandler = this.onChangeHandler.bind(this);
        this.onClick = this.onClick.bind(this);
        this.state = { selectedFile: ''};
    }

    onChangeHandler(ev) {
        if (ev.target.files && ev.target.files.length > 0) {
            //, "", "file", ev.target.files[0]);
            this.setState({ selectedFile: ev.target.files[0].name });
        }
        else {
            this.setState({ selectedFile: '' });
        }
        this.props.onChange(ev);
        this.file.value = null;
    }

    onClick(ev) {
        //const e = document.createEvent('HTMLEvents');
        //e.initEvent('click', true, false);
        this.file.click();//dispatchEvent(e);
    }

    render() {
        return <div style={this.props.style} className={"file-transfer upload" + (this.props.className || '')}>
            <input ref={myinput => (this.file = myinput)} type="file" onChange={this.onChangeHandler} style={{ display: 'none' }} />
            <div className="file-transfer-icon" style={this.props.icon ? { backgroundImage: 'url(' + this.props.icon + ')' } : null}></div>
            <UIButton className="modify" text={this.props.title} onClick={this.onClick} />
            <div className="file-transfer-filename ellipsis">{this.state.selectedFile}</div>
        </div>;
    }

}
export class UIDataTable extends React.Component {
    constructor(props) {
        super(props);

        this.navigationChange = this.navigationChange.bind(this);
        this.keyUp = this.keyUp.bind(this);
        this.pageChange = this.pageChange.bind(this);
        this.lostFocus = this.lostFocus.bind(this);
        this.sizeChange = this.sizeChange.bind(this);
        this.refresh = this.refresh.bind(this);

        this.currentPage = (!props.navigation) ? 0 : (props.navigation.pageNo.value + 1);

        this.state = {
            inputPage: this.currentPage.toString(),
            totPages: this.calculateTotPages(),
            pageSize: (!props.navigation) ? "0" : (props.navigation.pageSize.value)
        };
    }

    calculateTotPages() {
        if (!this.props.navigation ||
            !this.props.navigation.hasOwnProperty("totalItems")
            || this.props.navigation.totalItems == 0) return 0;

        let tp = this.props.navigation.totalItems.value / this.props.navigation.pageSize.value;
        if (tp - Math.floor(tp) > 0) tp = Math.floor(tp) + 1;
        return (tp === 0) ? 1 : tp;
    }

    componentDidUpdate() {
        if (!!this.props.navigation) {
            const tp = this.calculateTotPages();
            if (this.state.totPages !== tp) this.setState({ totPages: tp });

            if (this.state.pageSize !== this.props.navigation.pageSize.value)
                this.setState({ pageSize: this.props.navigation.pageSize.value });

            if (this.currentPage !== (this.props.navigation.pageNo.value + 1)) {
                this.currentPage = (this.props.navigation.pageNo.value + 1);
                this.setState({ inputPage: this.currentPage.toString() });
            }
        }
    }

    navigationChange(ev, nm, vl) {
        if (typeof vl !== 'number' || !isFinite(vl)) vl = this.currentPage - 1;
        switch (nm) {
            case "first":
                vl = 0;
                break;
            case "previous":
            case "pageNo":
                vl -= 1;
                break;
            case "next":
                vl += 1;
                break;
            case "last":
                vl = this.state.totPages - 1;
                break;
            default:
                break;
        }

        if (vl < 0) vl = 0;
        if (vl > this.state.totPages - 1) vl = this.state.totPages - 1;

        if (vl !== this.currentPage - 1) this.props.navigation.pageNo.change(ev, vl);
        else this.setState({ inputPage: this.currentPage.toString() });
    }

    sizeChange(ev){ //, name, value, source) {
        let value = ev.target.value;
        if (value !== this.props.navigation.pageSize.value)
            this.props.navigation.pageSize.change(ev, value);
        this.setState({ pageSize: value });
    }

    pageChange(ev) {
        let vl = ev.currentTarget.value;
        this.setState({ inputPage: vl });
    }

    lostFocus(ev) {
        let vl = parseInt(ev.currentTarget.value);
        if (this.currentPage !== vl)
            this.navigationChange(ev, "pageNo", isNaN(vl) ? 0 : vl);
    }

    keyUp(ev) {
        if (ev.keyCode === 13) {
            let vl = parseInt(ev.currentTarget.value);
            if (this.currentPage !== vl)
                this.navigationChange(ev, "pageNo", isNaN(vl) ? 0 : vl);
        }
    }

    refresh(ev) {
        if (typeof this.props.navigation.refresh === "function") this.props.navigation.refresh(ev, "refresh");
    }

    render() {
        let isExecuting = this.props.hasOwnProperty("isExecuting") && this.props.isExecuting ? true : false;
        const lk = this.props.listKey, md = this.props.managers, headerSource = "##header##";
        let mngCount = 0, navigation = (<div />);
        let captions = [];
        this.props.header.map(function (el, idx) {
            const mng = el.generic.manage;
            const key = "head-" + idx;
            const nm = el.generic.name;
            let col = null;
            switch (el.caption.type) {
                case "checkbox":
                    col = <UICheckbox key={key} name={nm} value={!!mng ? md[0][mngCount++] : el.caption.value}  onChange={(ev) => (el.generic.change(ev, nm, ev.currentTarget.checked, headerSource))} />;
                    break;
                case "label":
                    col = <div key={key}>{el.caption.value}</div>;
                    break;
                case "hidden":
                    break;
                default:
                    col = <div key={key}>{"unrecognized " + el.caption.type}</div>;
                    break;
            };
            if (col)
                captions.push(<div key={"panel-" + idx} className="entry-list-row-panel entry-list-row-header">{col}</div>);
            return col;

        });
        let entries;
        if (isExecuting)
            entries = (<div> Ordine in elaborazione </div>);
        else {
            entries = this.props.entries.map((row, rownum) => {
                mngCount = 0;
                const cols = this.props.header.map(function (el, idx) {
                    const mng = el.generic.manage;
                    const key = "col-" + idx;
                    const nm = el.generic.name;
                    let col, val, exVal = null;
                    let cClass = el.element.colClass;
                    let iClass = el.element.hasOwnProperty("itemClassFunc") ? el.element.itemClassFunc() : el.element.itemClass;
                    switch (el.element.type) {
                        case "hidden":
                            break;
                        case "checkbox":
                            //const label = null; // (!!el.element.value ? { class: el.element.textClass, text: el.element.value } : null);
                            val = (!!mng ? md[rownum + 1][mngCount++] : row[idx - mngCount]);
                            col = <UICheckbox key={key} name={nm} value={val}  onChange={(ev) => el.generic.change(ev, nm, ev.currentTarget.checked, row[lk])} />;
                            break;
                        case "label":
                            if (!!mng) val = md[rownum + 1][mngCount++];
                            else if (row[idx - mngCount] == null)
                                val = "";
                            else if (typeof row[idx - mngCount] === "string") val = row[idx - mngCount];
                            else {
                                val = row[idx - mngCount].val;
                            };
                            col = <div key={key}>{val}</div>;
                            break;
                        case "select":
                            val = (!!mng ? md[rownum + 1][mngCount++] : row[idx - mngCount]);
                            col = <UISelect key={key} name={nm} options={el.element.options} value={val} onChange={(ev) => el.generic.change(ev, nm, ev.currentTarget.value, row[lk])} />;
                            break;
                        case "link":
                            val = (!!mng ? md[rownum + 1][mngCount++] : row[idx - mngCount]);
                            col = <a href="#" name={nm} onClick={ev => el.generic.click(ev, rownum + 1, row[lk])}>{val}</a>;
                            break;
                        case "button":
                            let iName = '';
                            if (mng === 2 && !row[idx - mngCount]) cClass += " hidden";
                            if (mng === 3) exVal = row[idx - mngCount];
                            if (mng === 4) {
                                val = row[idx - mngCount].label;

                                if (row[idx - mngCount].hasOwnProperty("class")) {
                                    iClass = iClass + " " + row[idx - mngCount].class;
                                    iName = row[idx - mngCount].class;
                                }
                                exVal = row[idx - mngCount].value;
                            }
                            else
                                val = (!!mng ? el.element.options : row[idx - mngCount]);
                            if (val != null && val != "") {
                                col = <div><UIButton className={iClass || ''} onClick={ev => el.generic.click(ev, rownum + 1, row[lk])} name={iName} text={val} value={row[lk]} /></div>;
                            }
                            else {
                                col = <div/>;
                            }
                            mngCount += (!!mng ? 1 : 0);
                            break;
                        case "buttons-group": // buttons[{name, type, source, text, click}]
                            val = (!!mng ? el.element.options : row[idx - mngCount]);
                            const isDisabled = row.slice()?.pop()?.isDisabled
                            const buttons = val.map((txt, idx) => {
                                if(el.element.itemClass[idx] === 'return') {
                                    return <UIButton 
                                    key={"btn-"+idx}
                                    name={el.element.itemClass[idx]}
                                    className={el.element.itemClass[idx] || ''}
                                    onClick={ev => el.generic.click(ev, rownum + 1, row[lk])}
                                    text={val[idx]}
                                    disabled = {isDisabled} />
                                }

                                return  <UIButton 
                                            key={"btn-"+idx}
                                            name={el.element.itemClass[idx]}
                                            className={el.element.itemClass[idx] || ''}
                                            onClick={ev => el.generic.click(ev, rownum + 1, row[lk])}
                                            text={val[idx]}
                                             />

                            });
                            //col = (<UButtonsGroupFlat key={key} width={width} colClass={cClass} buttons={buttons} />);
                            col = <UIButtonPad>{buttons}</UIButtonPad>;
                            mngCount += (!!mng ? 1 : 0);
                            break;
                        case "dot":
                            val = row[idx - mngCount];
                            mngCount += (!!mng ? 1 : 0);
                            let cName = (val == '' ? iClass : val);
                            col = (<div key={key} className={cName}></div>);
                            break;
                        case "image":
                            val = row[idx - mngCount];
                            mngCount += (!!mng ? 1 : 0);
                            col = (val == '' ? '' : (<div key={key} className=""><img src={val}></img></div>));
                            break;
                        case "span":
                            val = row[idx - mngCount];
                            mngCount += (!!mng ? 1 : 0);
                            let spanClick = function () { };
                            if (el.generic.click != null) {
                                spanClick = function (ev) {
                                    let target = ev.target;
                                    el.generic.click(ev, rownum, val);
                                }
                            }
                            col = <div key={key}>
                                <div data-val={val.dataVal ? val.dataVal : ''} onClick={spanClick}/>
                            </div>;
                            break;
                        case "tooltip":
                            val = row[idx - mngCount];
                            mngCount += (!!mng ? 1 : 0);
                            // let cName = (val == '' ? iClass : val);
                            if(val === 'KO') {
                                col = (<div key={key} >
                                    <Tooltip title='Indirizzo errato' position='top'>
                                        <div className='btn btn-default'> <img  src={errorIcon}/></div>
                                    </Tooltip>
                                </div>);
                            } else if(val === 'OK') {
                                col = (<div key={key} >
                                    <Tooltip  title='Indirizzo corretto' position='top'>
                                        <div className='btn btn-default'> <img  src={okIcon}/></div>
                                    </Tooltip>
                                    </div>);
                            } else if(val === 'VERIFY') {
                                col = (<div key={key} >
                                    <Tooltip title='Verificare indirizzo' position='top'>
                                        <div className='btn btn-default'> <img  src={warningIcon}/></div>
                                    </Tooltip>
                                </div>);
                            }else {
                                col = (<div key={key} >
                                   <div></div>
                                </div>);
                            }
                            break;
                        case "component": {
                            // se la colonna è "managed" prendiamo dai managers, altrimenti dal valore della riga
                            val = (!!mng ? md[rownum + 1][mngCount++] : row[idx - mngCount]);

                            // se ti serve la classe, la applichiamo al contenitore
                            col = (
                                <div key={key} className={iClass}>
                                    {
                                        React.isValidElement(val)
                                            ? val                                 // JSX passato da entries (es. <div className="services-icons">...</div>)
                                            : (val ?? "")                         // fallback se arriva testo
                                    }
                                </div>
                            );
                            break;
                        }
                        default:
                            col = <div key={key}>{"unrecognized " + el.caption.type}</div>;
                            break;
                    };
                    return col ? <div className="entry-list-row-panel" key={"panel-" + idx}>{col}</div> : null;
                });
                return cols;
            }, this);
        }
            
        const pgszopts = [{ value: 5, text: "5" }, { value: 10, text: "10" }, { value: 20, text: "20" }, { value: 30, text: "30" }, { value: 50, text: "50" }];

        if (!!this.props.navigation) {
            let selectSize = "";
            let navigatePage = "";
            //if (this.props.navigation.totalItems.value > 0) {
                selectSize = <div className="pager-pagesize"><UISelect name="pagesize" label={this.props.navigation.pageSize.text} options={pgszopts} value={this.state.pageSize} onChange={this.sizeChange} /></div>;

                    /*(<div className="row">
                    <USelectFlat name="pagesize" grow={false} width="7rem" colClass="no-padding-right" source={"list-" + this.props.listId}
                    options={pgszopts} selection={this.state.pageSize} onChange={this.sizeChange} />
                    <ULabelFlat colClass="no-padding-left" value={this.props.navigation.pageSize.text} /></div>);*/

                navigatePage = <div className="pager-navigation">
                    <div className={"link " + (this.currentPage > 1 ? '' : 'disabled')} onClick={(ev) => this.navigationChange(ev, "first", "pageNo")} name="first">{"|<"}</div>
                    <div className={"link " + (this.currentPage > 1 ? '' : 'disabled')} onClick={(ev) => this.navigationChange(ev, "previous", "pageNo")} name="previous">{"<"}</div>
                    <div><UIInput disabled={this.state.totPages <= 1} name="pageNo" onChange={this.pageChange} onKeyUp={this.keyUp} onBlur={this.lostFocus} value={this.state.inputPage} label={"/" + this.state.totPages.toString()}/></div>
                    <div className={"link " + (this.currentPage < this.state.totPages ? '' : 'disabled')} onClick={(ev) => this.navigationChange(ev, "next", "pageNo")} name="next">{">"}</div>
                    <div className={"link " + (this.currentPage < this.state.totPages ? '' : 'disabled')} onClick={(ev) => this.navigationChange(ev, "last", "pageNo")} name="last">{">|"}</div>
                </div>;
                    /*(<div className="row"><ULinkFlat grow={false} width="4rem" colClass="no-padding-right" onClick={this.navigationChange} name="first" source="pageNo" text="|<<" />
                    <ULinkFlat grow={false} width="2rem" colClass="no-padding" onClick={this.navigationChange} name="previous" source="pageNo" text="<" />
                    <UInputFlat itemClass={"nav-page-counter-first"} grow={false} width="3rem" colClass="no-padding" name="pageNo" source="pageNo" type="text"
                        onChange={this.pageChange} onKeyUp={this.keyUp} onBlur={this.lostFocus} value={this.state.inputPage} />
                    <ULabelFlat grow={false} width="3rem" colClass="no-padding nav-page-counter-second" value={"\xa0/ " + this.state.totPages.toString()} />
                    <ULinkFlat grow={false} width="2rem" colClass="no-padding" onClick={this.navigationChange} name="next" source="pageNo" text=">" />
                    <ULinkFlat grow={false} width="4rem" colClass="no-padding-left" onClick={this.navigationChange} name="last" source="pageNo" text=">>|" /></div>);*/
            //}


            //if (!!this.props.navigation && this.props.navigation.totalItems.value > 0) {
            navigation = <div key="pager" className="pager">
                {selectSize}
                 <div className="pager-refresh"><UIButton className="modify" icon="../images/Refresh.png" disabled={(typeof this.props.navigation.refresh === "function") ? "" : "disabled"} name="refresh" text={Languages.getSection('Main').refreshLabel} onClick={this.refresh} /></div>
                {navigatePage}
            </div>;
        }

        let style;
        if (this.props.header[0].caption.type == 'checkbox') {
            style = 'min-content ' + 'auto '.repeat(Math.max(0,captions.length - 2)) + 'min-content';
        }
        else {
            style = 'auto '.repeat(Math.max(0, captions.length - 1)) + 'min-content';
        }

        return (
            <div className="report-table">
                <div key="rep-1" className="entry-list" style={{gridTemplateColumns: style}}>
                    {captions}
                    {entries}
                </div>
                {navigation}
            </div>
        );
    }
}
export class UIPagination extends React.Component {
    constructor(props) {
        super(props);

        this.navigationChange = this.navigationChange.bind(this);
        this.keyUp = this.keyUp.bind(this);
        this.pageChange = this.pageChange.bind(this);
        this.lostFocus = this.lostFocus.bind(this);
        this.sizeChange = this.sizeChange.bind(this);
        this.refresh = this.refresh.bind(this);

        this.currentPage = (!props.navigation) ? 0 : (props.navigation.pageNo.value + 1);

        this.state = {
            inputPage: this.currentPage.toString(),
            totPages: this.calculateTotPages(),
            pageSize: (!props.navigation) ? "0" : (props.navigation.pageSize.value)
        };
    }


    calculateTotPages() {
        if (!this.props.navigation || !this.props.navigation.hasOwnProperty("totalItems") || this.props.navigation.totalItems == 0) {
            return 0;
        }

        let tp = this.props.navigation.totalItems.value / this.props.navigation.pageSize.value;
        if (tp - Math.floor(tp) > 0) {
            tp = Math.floor(tp) + 1;
        }
        return (tp === 0) ? 1 : tp;
    }

    componentDidUpdate() {
        if (!!this.props.navigation) {
            const tp = this.calculateTotPages();
            if (this.state.totPages !== tp) this.setState({ totPages: tp });

            if (this.state.pageSize !== this.props.navigation.pageSize.value)
                this.setState({ pageSize: this.props.navigation.pageSize.value });

            if (this.currentPage !== (this.props.navigation.pageNo.value + 1)) {
                this.currentPage = (this.props.navigation.pageNo.value + 1);
                this.setState({ inputPage: this.currentPage.toString() });
            }
        }
    }

    navigationChange(ev, nm, vl) {
        if (typeof vl !== 'number' || !isFinite(vl)) vl = this.currentPage - 1;
        switch (nm) {
            case "first":
                vl = 0;
                break;
            case "previous":
            case "pageNo":
                vl -= 1;
                break;
            case "next":
                vl += 1;
                break;
            case "last":
                vl = this.state.totPages - 1;
                break;
            default:
                break;
        }

        if (vl < 0) vl = 0;
        if (vl > this.state.totPages - 1) vl = this.state.totPages - 1;

        if (vl !== this.currentPage - 1) this.props.navigation.pageNo.change(ev, vl);
        else this.setState({ inputPage: this.currentPage.toString() });
    }

    sizeChange(ev){ //, name, value, source) {
        let value = ev.target.value;
        if (value !== this.props.navigation.pageSize.value) {
            this.props.navigation.pageSize.change(ev, value);
        }
        this.setState({ pageSize: value });
    }

    pageChange(ev) {
        let vl = ev.currentTarget.value;
        this.setState({ inputPage: vl });
    }

    lostFocus(ev) {
        let vl = parseInt(ev.currentTarget.value);
        if (this.currentPage !== vl) {
            this.navigationChange(ev, "pageNo", isNaN(vl) ? 0 : vl);
        }
    }

    keyUp(ev) {
        if (ev.keyCode === 13) {
            let vl = parseInt(ev.currentTarget.value);
            if (this.currentPage !== vl) {
                this.navigationChange(ev, "pageNo", isNaN(vl) ? 0 : vl);
            }
        }
    }

    refresh(ev) {
        if (typeof this.props.navigation.refresh === "function") {
            this.props.navigation.refresh(ev, "refresh");
        }
    }

    render() {
        const pgszopts = [{ value: 5, text: "5" }, { value: 10, text: "10" }, { value: 20, text: "20" }, { value: 30, text: "30" }, { value: 50, text: "50" }];
        let navigation = (<div />);
        if (!!this.props.navigation) {
            let selectSize = "";
            let navigatePage = "";
                selectSize = <div className="pager-pagesize">
                    <UISelect
                    name="pagesize" 
                    label={this.props.navigation.pageSize.text}
                    options={pgszopts}
                    value={this.state.pageSize}
                    onChange={this.sizeChange} /></div>;

                navigatePage = <div className="pager-navigation">
                    <div className={"link " + (this.currentPage > 1 ? '' : 'disabled')} onClick={(ev) => this.navigationChange(ev, "first", "pageNo")} name="first">{"|<"}</div>
                    <div className={"link " + (this.currentPage > 1 ? '' : 'disabled')} onClick={(ev) => this.navigationChange(ev, "previous", "pageNo")} name="previous">{"<"}</div>
                    <div><UIInput disabled={this.state.totPages <= 1} name="pageNo" onChange={this.pageChange} onKeyUp={this.keyUp} onBlur={this.lostFocus} value={this.state.inputPage} label={"/" + this.state.totPages.toString()}/></div>
                    <div className={"link " + (this.currentPage < this.state.totPages ? '' : 'disabled')} onClick={(ev) => this.navigationChange(ev, "next", "pageNo")} name="next">{">"}</div>
                    <div className={"link " + (this.currentPage < this.state.totPages ? '' : 'disabled')} onClick={(ev) => this.navigationChange(ev, "last", "pageNo")} name="last">{">|"}</div>
                </div>;
              

            navigation = <div key="pager" className="pager">
                {selectSize}
                <div className="pager-refresh"><UIButton className="modify" icon="../images/Refresh.png" disabled={(typeof this.props.navigation.refresh === "function") ? "" : "disabled"} name="refresh" text={Languages.getSection('Main').refreshLabel} onClick={this.refresh} /></div>
                {navigatePage}
            </div>;
        }

        return (
            <div className="report-table">
                {navigation}
            </div>
        );
    }
}
export class UIOrderPackageConfig extends React.Component {
    constructor(props) {
        /*
         * title
         * index
         * data
         * texts
         * onChange
         * onAdd
         */
        super(props);
    }

    render() {
        let addBtn = this.props.onAdd && <AddConfig onClick={this.props.onAdd} />
        let delBtn = this.props.onRemove && <div 
                                                className="order-package-remove"
                                                onClick={this.props.onRemove}>
                                                    <img src={RemoveIcon} />
                                            </div>
        return <>
            <div className={"order-package" + (this.props.disabled ? " disabled" : "")} >
                <div className='order-package-setings'>
                    <div className="order-package-title">{this.props.title}</div>
                    {delBtn}
                </div>
                <div className="order-package-content">
                    <div>
                        <UISelect
                                name="choosePackageConfig"
                                onChange={this.props.packageOptionChange}
                                value={this.props?.packageOptionValue?.value}
                                options={this.props.packageOptions}
                                className="select-white" />
                    </div>
                    <div className="order-package-body">
                        {this.props.data.map((el) => {
                            const formatedLabel = `${el.text} (${el.unit})`;
                            return (
                                <UIInput 
                                    key={el.id}
                                    className="order-package-item"
                                    name={el.id}
                                    label={formatedLabel}
                                    value={el.value}
                                    onChange={this.props.onChange}
                                    error={el.error}
                                    mandatory={true}/>
                            )
                        })}
                    </div>

                </div>
               
            </div>
            {addBtn}
        </>
    }
}
export class UIGraphic extends React.Component {
    constructor(props) {
        super(props);
        //this.canvas = React.createRef();
    }

    /*componentDidUpdate() {
        const sizeX = this.canvas.current.width = 1000;
        const sizeY = this.canvas.current.height = 500;
        const data = this.props.data;
        const maxAbs = this.props.maxAbs;
        const dataout = data.map(v => (maxAbs == 0 ? 0 : v / maxAbs));
        let ctx = this.canvas.current.getContext("2d");
        const gradW = sizeX * 0.9 / dataout.length;
        const spc = sizeX * 0.1 / (dataout.length - 1);

        dataout.forEach((el, idx) => {
            const startH = (gradW + spc) * idx;
            const endV = (1 - el) * sizeY;
            let grd = ctx.createLinearGradient(startH, endV, startH, sizeY * el);
            grd.addColorStop(0, 'rgba(249, 174, 49, 0)');
            grd.addColorStop(1, 'rgba(249, 174, 49, 1)');
            ctx.fillStyle = '#f9ae31';
            ctx.fillRect(startH, endV, gradW, sizeY * el);
        });
    }*/

    render() {
        return <div className="widget uigraphic">
            <div className="widget-header">&nbsp;</div>
            <div className="widget-content">
                <div className="widget-content-title">{this.props.title}</div>
                <div style={{ width: '100%', height: '100%', position: 'relative' }}>
                    <div style={{ width: '100%', height: '100%', position: 'absolute', top: 0, left: 0 }}>
                        <ResponsiveContainer width="99%" height="99%">
                            <LineChart
                                width="100%"
                                height="100%"
                                data={this.props.data}
                                margin={{ top: 0, right: 14, left: 0, bottom: 0 }}>
                                <Line type="monotone" dataKey="value" stroke="#f9a331" strokeWidth="2" />
                                <CartesianGrid strokeDasharray="3 3" />
                                <XAxis dataKey="name" />
                                <YAxis />
                                <ChartTooltip />
                            </LineChart>
                        </ResponsiveContainer>
                    </div>
                </div>
            </div>
        </div>;
    }
}
export class UISelectFieldTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedRows: {},
            currentPage: 1,
            itemsPerPage: props.defaultItemsPerPage || 10,
            showOnlyErrors: false,
        };
        this.le = Languages.Components.UISelectFieldTable[Languages.selectedLanguage];
    }

    componentDidUpdate(prevProps) {
        if (
            !this.props.serverSidePagination &&
            prevProps.items !== this.props.items &&
            this.state.currentPage !== 1
        ) {
            this.setState({ currentPage: 1 });
        }
    }

    getSelectionDisabledReason = (item) => {
        const avaibleQuantity =
            Number(item.avaibleQuantity);

        if (
            !avaibleQuantity ||
            avaibleQuantity <= 0
        ) {
            return (
                this.le.unavailableProductTooltip ||
                ""
            );
        }

        if (this.hasDifferentDealer(item)) {
            return (
                this.props.differentDealerTooltip || ""
            );
        }

        return "";
    };

    isChecked = (id) => {
        return !!this.state.selectedRows[id];
    };

    isSelectionDisabled = (item) => {
        const avaibleQuantity =
            Number(item.avaibleQuantity);

        const isUnavailable =
            !avaibleQuantity ||
            avaibleQuantity <= 0;

        const hasDifferentDealer =
            this.hasDifferentDealer(item);

        return (
            isUnavailable ||
            hasDifferentDealer
        );
    };

    getColumnClass = (header) => {
        return `col-${header.size || 2} ${header.className || ""}`;
    };

    getQuantity = (id) => {
        return this.state.selectedRows[id]?.quantity || "";
    }

    getDealerCode = (item) => {
        return String(
            item?.dealerCode || ""
        ).trim();
    };

    hasDifferentDealer = (item) => {
        const selectedDealerCode = String(
            this.props.selectedDealerCode || ""
        ).trim();

        if (!selectedDealerCode) {
            return false;
        }

        const itemDealerCode =
            this.getDealerCode(item);

        return (
            itemDealerCode !== selectedDealerCode
        );
    };

    handleCheckboxChange = (item) => { 

        if (this.isSelectionDisabled(item)) {
            return;
        }

        const { rowKey = "id" } = this.props;
        const id = item[rowKey];

        this.setState((prevState) => {
            const alreadySelected = !!prevState.selectedRows[id];
            const newSelectedRows = { ...prevState.selectedRows };

            if (alreadySelected) {
                delete newSelectedRows[id];
            } else {
                newSelectedRows[id] = {
                    quantity: 1,
                    itemData: item,
                };
            }

            return { selectedRows: newSelectedRows };
        }, () => {
            this.notifySelectionChange(this.state.selectedRows);
        });
    };

    handleQuantityChange = (item, value) => {
        const { rowKey = "id" } = this.props;
        const id = item[rowKey];

        if (!this.state.selectedRows[id]) {
                return null;
            }


        this.setState((prevState) => ({
            selectedRows: {
                ...prevState.selectedRows,
                [id]: {
                    ...(prevState.selectedRows[id] || { itemData: item }),
                    quantity: value,
                    itemData: item,
                },
            },
        }), () => {
            this.notifySelectionChange(this.state.selectedRows);
        });
    };

    notifySelectionChange = (selectedRows) => {
        const selectedData = Object.values(selectedRows).map((row) => ({
            ...row.itemData,
            quantity: row.quantity,
        }));

        if (this.props.onSelectionChange) {
            this.props.onSelectionChange(selectedData);
        }
    };

    handleItemsPerPageChange = (value) => {
        const pageSize = parseInt(value, 10);

        if (this.props.serverSidePagination) {
            if (this.props.onItemsPerPageChange) {
                this.props.onItemsPerPageChange(pageSize);
            }
            return;
        }

        this.setState({
            itemsPerPage: pageSize,
            currentPage: 1,
        });
    }

    changePage = (page) => {
        if (this.props.serverSidePagination) {
            if (
                page >= 1 &&
                page <= this.props.totalPages &&
                this.props.onPageChange
            ) {
                this.props.onPageChange(page);
            }
            return;
        }

        const { totalPages } = getPaginatedData({
            items: this.props.items,
            currentPage: this.state.currentPage,
            itemsPerPage: this.state.itemsPerPage,
        });

        if (page >= 1 && page <= totalPages) {
            this.setState({ currentPage: page });
        }
    };

    getSummaryData = () => {
        const { headers, rowKey = "id" } = this.props;
        const firstTwoHeaders = headers.slice(0, 2);

        return Object.values(this.state.selectedRows).map((row) => ({
            id: row.itemData[rowKey],
            itemData: row.itemData,
            values: firstTwoHeaders.map((header) => row.itemData[header.field]),
            quantity: row.quantity,
        }));
    };

    removeSelectedItem = (id) => {
        this.setState((prevState) => {
            const newSelectedRows = { ...prevState.selectedRows };
            delete newSelectedRows[id];
            return {
                selectedRows: newSelectedRows,
            };
        }, () => {
            this.notifySelectionChange(this.state.selectedRows);
        });
    };

    handleToggleShowOnlyErrors = (e) => {
        this.setState({
            showOnlyErrors: e.target.checked,
        });
    };

    renderSummaryTable() {
        const { headers, errors = {} } = this.props;
        const { showOnlyErrors } = this.state;
        const firstTwoHeaders = headers.slice(0, 2);
        const summaryData = this.getSummaryData();
        const quantityErrors = errors.quantity || {};

        const filteredSummaryData = showOnlyErrors
            ? summaryData.filter((row) => quantityErrors[row.id])
            : summaryData;

        return (
            <div className="selected-summary">
                <div className="selected-summary-header">
                <strong className="selected-summary-title">{this.le.selectedProduct}</strong>

                    <label className="summary-filter-toggle">
                        <input
                            type="checkbox"
                            checked={showOnlyErrors}
                            onChange={this.handleToggleShowOnlyErrors}
                        />
                        {this.le.showOnlyErrorsField}
                    </label>
                </div>

                {filteredSummaryData.length === 0 ?
                    (
                        <p className="selected-summary-empty">
                            {showOnlyErrors
                                ? this.le.noErrorsField
                                : this.le.nothingSelected
                            }
                        </p>
                    ) : (
                        <div className="summary-table-wrapper">
                            <table className=" summary-table">
                                <thead>
                                    <tr>
                                        {firstTwoHeaders.map((header, index) => (
                                            <th key={`${header.field}-${index}`}>
                                                {header.label}</th>
                                        ))}
                                        <th>{this.le.quantity}</th>
                                        <th>{this.le.actions[0]}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredSummaryData.map((row) => (
                                        <tr key={row.id}>
                                            {firstTwoHeaders.map((header, index) => {
                                                const value = row.itemData[header.field];

                                                return (
                                                    <td
                                                        key={`${row.id}-${header.field}`}
                                                        className={header.className || ""}
                                                    >
                                                        <div className="table-cell-content">
                                                            <span className="table-cell-text">
                                                                {value}
                                                            </span>
                                                        </div>
                                                    </td>
                                                );
                                            })}
                                            <td>
                                                <input
                                                    type="number"
                                                    min="0"
                                                    className={`summary-quantity-input ${quantityErrors[row.id] ? "input-error" : ""}`}
                                                    value={row.quantity}
                                                    onKeyDown={(e) => {
                                                        if (["e", "E", "+", "-"].includes(e.key)) {
                                                            e.preventDefault();
                                                        }
                                                    }}
                                                    onChange={(e) =>
                                                        this.handleQuantityChange(row.itemData, e.target.value)}
                                                />
                                            </td>
                                            <td>
                                                <button
                                                    type="button"
                                                    className="summary-remove-icon-button"
                                                    onClick={() => this.removeSelectedItem(row.id)}
                                                    aria-label={this.le.actions[1]}
                                                >
                                                    X
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
            </div>
        );
    }

    render() {
        const {
            headers = [],
            items = [],
            rowKey = "id",
            maxHeight = "auto",
            errors = {},
            serverSidePagination = false
        } = this.props;

        const currentPage = serverSidePagination
            ? this.props.currentPage
            : this.state.currentPage;

        const itemsPerPage = serverSidePagination
            ? this.props.itemsPerPage
            : this.state.itemsPerPage;

        const quantityErrors = errors?.quantity || {};

        const paginationData = serverSidePagination
            ? {
                totalItems: this.props.totalItems,
                totalPages: this.props.totalPages,
                paginatedItems: items,
            }
            : getPaginatedData({
                items,
                currentPage,
                itemsPerPage,
            });

        const {
            totalItems,
            totalPages,
            paginatedItems,
        } = paginationData;

        const rowsHeight = 100;
        const headerHeight = 100;
        const maxRows = 4;

        const visibleRows = Math.min(paginatedItems.length, maxRows);
        const hasItems = paginatedItems.length > 0;

        const tableHeight = hasItems
            ? headerHeight + visibleRows * rowsHeight
            : 300;

        return (
            <div className="selectable-table-container" style={{ height: maxHeight }}>
                <div className="selectable-table-box">
                    <div className="selectable-table-viewport">
                        <div
                            className={`selectable-table-wrapper ${!hasItems ? "selectable-table-wrapper-empty" : ""}`}
                            style={{
                                height: tableHeight,
                                minHeight: tableHeight,
                                maxHeight: tableHeight
                            }}
                        >
                            {!hasItems ? (
                                <div className="empty-table-state">
                                    <div className="empty-table-card">
                                        <div className="empty-table-icon">
                                            <i className="fa-solid fa-magnifying-glass"></i>
                                        </div>

                                        <div className="empty-table-title">
                                            {this.le.noData}
                                        </div>

                                        <div className="empty-table-subtitle">
                                            Usa i filtri e avvia una ricerca per visualizzare i prodotti disponibili.
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <table className="selectable-table">
                                    <thead>
                                        <tr>
                                            <th>{this.le.select}</th>
                                            {headers.map((header, index) => (
                                                <th
                                                    key={`${header.field}-${index}`}
                                                    className={this.getColumnClass(header)}
                                                >
                                                    {header.label}
                                                </th>
                                            ))}
                                            <th>{this.le.quantity}</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {paginatedItems.map((item, rowIndex) => {
                                            const id = item[rowKey];
                                            const checked = this.isChecked(id);
                                            const quantity = this.getQuantity(id);
                                            const disabledSelection = this.isSelectionDisabled(item);
                                            const disabledSelectionReason =
                                                this.getSelectionDisabledReason(item);

                                            const differentDealer =
                                                this.hasDifferentDealer(item);

                                            return (
                                                <tr
                                                    key={id}
                                                    className={[
                                                        checked ? "row-selected" : "",
                                                        rowIndex >= paginatedItems.length - 3 ? "tooltip-up-row" : ""
                                                    ].filter(Boolean).join(" ")}
                                                >
                                                    <td>
                                                        <div
                                                            className={[
                                                                "selection-checkbox-wrapper",
                                                                disabledSelection
                                                                    ? "selection-checkbox-disabled"
                                                                    : "",
                                                                differentDealer
                                                                    ? "selection-checkbox-different-dealer"
                                                                    : ""
                                                            ].filter(Boolean).join(" ")}
                                                        >
                                                            <input
                                                                type="checkbox"
                                                                checked={checked}
                                                                disabled={disabledSelection}
                                                                onChange={() =>
                                                                    this.handleCheckboxChange(item)
                                                                }
                                                            />

                                                            {disabledSelectionReason && (
                                                                <span className="selection-disabled-tooltip">
                                                                    <span className="selection-tooltip-title">
                                                                        <i className="fa-solid fa-circle-info"></i>

                                                                        {differentDealer
                                                                            ? "Dealer differente"
                                                                            : "Prodotto non disponibile"}
                                                                    </span>

                                                                    <span className="selection-tooltip-text">
                                                                        {disabledSelectionReason}
                                                                    </span>
                                                                </span>
                                                            )}
                                                        </div>
                                                    </td>

                                                    {headers.map((header) => {
                                                        const value = item[header.field];

                                                        return (
                                                            <td
                                                                key={header.field}
                                                                className={this.getColumnClass(header)}
                                                            >
                                                                <div className="table-cell-content">
                                                                    <span className="table-cell-text">
                                                                        {value}
                                                                    </span>

                                                                    {value && value.length > 80 && (
                                                                        <span className="description-tooltip-icon">
                                                                            <i className="fa-regular fa-circle-info"></i>
                                                                            <span className="description-tooltip">
                                                                                {value}
                                                                            </span>
                                                                        </span>
                                                                    )}
                                                                </div>
                                                            </td>
                                                        );
                                                    })}

                                                    <td>
                                                        <input
                                                            type="number"
                                                            min="0"
                                                            value={quantity}
                                                            disabled={!checked}
                                                            className={quantityErrors[id] ? "input-error" : ""}
                                                            onKeyDown={(e) => {
                                                                if (["e", "E", "+", "-"].includes(e.key)) {
                                                                    e.preventDefault();
                                                                }
                                                            }}
                                                            onChange={(e) =>
                                                                this.handleQuantityChange(item, e.target.value)
                                                            }
                                                        />
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            )}
                        </div>

                        {hasItems && (
                            <UITablePagination
                                currentPage={currentPage}
                                itemsPerPage={itemsPerPage}
                                totalPages={totalPages}
                                totalItems={totalItems}
                                pageSizeOptions={[5, 10, 20, 30]}
                                onPageChange={this.changePage}
                                onItemsPerPageChange={this.handleItemsPerPageChange}
                            />
                        )}
                    </div>
                </div>

                {this.renderSummaryTable()}
            </div>
        );
    }
}
export class UITablePagination extends React.Component {

    constructor(props) {
        super(props);
        this.le = Languages.Components.UITablePagination[Languages.selectedLanguage];

    }

    render() {
        const {
            currentPage,
            itemsPerPage,
            totalPages,
            totalItems,
            pageSizeOptions = [5, 10, 20, 30],
            onPageChange,
            onItemsPerPageChange,
        } = this.props;

        const startItem = (currentPage - 1) * itemsPerPage + 1;
        const endItem = Math.min(currentPage * itemsPerPage, totalItems);
        const visiblePages = getVisiblePages(totalPages, currentPage);

        return (
            <div className="ui-pagination-container">
                <div className="ui-pagination-card">
                    <div className="ui-pagination-left">
                        <span className="ui-pagination-results">
                            {startItem}-{endItem} {this.le.pagination[0]} {totalItems}
                        </span>
                        <div className="ui-pagination-page-size">
                            <label htmlFor="itemsPerPageSelect">{this.le.pagination[1]}</label>
                            <select
                                id="itemsPerPageSelect"
                                value={itemsPerPage}
                                onChange={(e) => onItemsPerPageChange(Number(e.target.value))}
                            >
                                {pageSizeOptions.map((option) => (
                                    <option key={`page-size-${option}`} value={option}>
                                        {option}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                    <div className="ui-pagination-center">
                        <button
                            type="button"
                            className="ui-page-nav"
                            onClick={() => onPageChange(currentPage - 1)}
                            disabled={currentPage === 1}
                        >
                            &lt;
                        </button>
                        {visiblePages.map((page, index) =>
                            page === "dots" ? (
                                <span
                                    key={`dots-${index}`}
                                    className="ui-page-dots"
                                >
                                    ...
                                </span>
                            ) : (
                                <button
                                    key={`page-${page}`}
                                    type="button"
                                    className={`ui-page-number ${currentPage === page ? "is-active" : ""}`}
                                    onClick={() => onPageChange(page)}
                                >
                                    {page}
                                </button>
                            )
                        )}

                        <button
                            type="button"
                            className="ui-page-nav"
                            onClick={() => onPageChange(currentPage + 1)}
                            disabled={currentPage === totalPages}
                        >
                            &gt;
                        </button>
                    </div>

                    <div className=" ui-pagination-right">
                        <span className="ui-pagination-summary">
                            {this.le.pagination[2]} {currentPage} / {totalPages}
                        </span>
                    </div>
                </div>
            </div>
        );
    }

}
export class UITableWithPagination extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            currentPage: 1,
            itemsPerPage: props.defaultItemsPerPage || 10
        };

        this.le = Languages.Components.UITableWithPagination[Languages.selectedLanguage];
    }

    componentDidUpdate(prevProps) {
        if (this.props.serverSidePagination) {
            return;
        }

        if (prevProps.items !== this.props.items && this.state.currentPage !== 1) {
            this.setState({
                currentPage: 1
            });
        }
    }

    handleItemsPerPageChange = value => {
        const pageSize = parseInt(value, 10);

        if (Number.isNaN(pageSize)) {
            return;
        }

        if (this.props.serverSidePagination) {
            if (typeof this.props.onItemsPerPageChange === "function") {
                this.props.onItemsPerPageChange(pageSize);
            }

            return;
        }

        this.setState({
            itemsPerPage: pageSize,
            currentPage: 1
        });
    };

    changePage = page => {
        if (this.props.serverSidePagination) {
            if (page >= 1 && page <= this.props.totalPages && typeof this.props.onPageChange ===
                "function") {
                this.props.onPageChange(page);
            }

            return;
        }

        const {
            totalPages
        } = getPaginatedData({
            items: this.props.items,
            currentPage: this.state.currentPage,
            itemsPerPage: this.state.itemsPerPage
        });

        if (page >= 1 && page <= totalPages
        ) {
            this.setState({
                currentPage: page
            });
        }
    };

    renderCell = (
        header,
        item,
        rowId,
        colIndex
    ) => {
        const cellValue = item[header.field];

        const renderedContent =
            typeof header.render === "function"
                ? header.render(
                    cellValue,
                    item
                )
                : cellValue;

        const isActionColumn = header.type === "actions";

        const cellClassName = [
            header.className || "",
            isActionColumn
                ? "readonly-table-actions-cell"
                : ""
        ]
            .filter(Boolean)
            .join(" ");

        return (
            <td
                key={`${rowId}-${colIndex}`}
                className={cellClassName}
            >
                <div
                    className={
                        isActionColumn
                            ? "table-cell-content table-cell-actions"
                            : "table-cell-content"
                    }
                >
                    {isActionColumn ? (
                        renderedContent
                    ) : (
                        <>
                            <span className="table-cell-text">
                                {renderedContent}
                            </span>

                            {header.field === "description" &&
                                cellValue &&
                                String(cellValue).length > 80 && (
                                    <span className="description-tooltip-icon">
                                        <i
                                            className="fa-regular fa-circle-info"
                                            aria-hidden="true"
                                        />

                                        <span className="description-tooltip">
                                            {cellValue}
                                        </span>
                                    </span>
                                )}
                        </>
                    )}
                </div>
            </td>
        );
    };

    renderTableHeader = headers => {
        return (
            <thead>
                <tr>
                    {headers.map(
                        (
                            header,
                            index
                        ) => {
                            const isActionColumn = header.type === "actions";

                            const headerClassName = [
                                header.className || "",
                                isActionColumn
                                    ? "readonly-table-actions-header"
                                    : ""
                            ]
                                .filter(Boolean)
                                .join(" ");

                            return (
                                <th
                                    key={`${header.field || "col"}-${index}`}
                                    className={headerClassName}
                                    scope="col"
                                >
                                    {header.label}
                                </th>
                            );
                        }
                    )}
                </tr>
            </thead>
        );
    };

    renderTableBody = (
        headers,
        paginatedItems,
        rowKey,
        startIndex
    ) => {
        return (
            <tbody>
                {paginatedItems.map(
                    (
                        item,
                        rowIndex
                    ) => {
                        const rowId =
                            item[rowKey] !== null &&
                                item[rowKey] !== undefined
                                ? String(
                                    item[rowKey]
                                )
                                : `row-${startIndex + rowIndex}`;

                        const tooltipClass =
                            rowIndex >=
                                paginatedItems.length - 3
                                ? "tooltip-up-row"
                                : "";

                        return (
                            <tr
                                key={rowId}
                                className={
                                    tooltipClass
                                }
                            >
                                {headers.map(
                                    (
                                        header,
                                        colIndex
                                    ) =>
                                        this.renderCell(
                                            header,
                                            item,
                                            rowId,
                                            colIndex
                                        )
                                )}
                            </tr>
                        );
                    }
                )}
            </tbody>
        );
    };

    renderEmptyState = () => {
        return (
            <div className="readonly-empty-table-state">
                <div className="empty-table-card">
                    <div className="empty-table-icon">
                        <i
                            className="fa-solid fa-magnifying-glass"
                            aria-hidden="true"
                        />
                    </div>

                    <div className="empty-table-title">
                        {this.le.noData}
                    </div>
                </div>
            </div>
        );
    };

    render() {
        const {
            headers = [],
            items = [],
            rowKey = "id",
            maxHeight = "auto",
            serverSidePagination = false,
            visibleRows = 10
        } = this.props;

        const currentPage =
            serverSidePagination
                ? this.props.currentPage || 1
                : this.state.currentPage;

        const itemsPerPage =
            serverSidePagination
                ? this.props.itemsPerPage ||
                this.state.itemsPerPage
                : this.state.itemsPerPage;

        const paginationData =
            serverSidePagination
                ? {
                    totalItems:
                        this.props.totalItems || 0,

                    totalPages:
                        this.props.totalPages || 0,

                    paginatedItems:
                        Array.isArray(items)
                            ? items
                            : [],

                    startIndex:
                        (currentPage - 1) *
                        itemsPerPage
                }
                : getPaginatedData({
                    items:
                        Array.isArray(items)
                            ? items
                            : [],
                    currentPage,
                    itemsPerPage
                });

        const {
            totalItems,
            totalPages,
            paginatedItems,
            startIndex
        } = paginationData;

        const hasItems =
            Array.isArray(paginatedItems) &&
            paginatedItems.length > 0;

        return (
            <div
                className="readonly-table-container"
                style={{
                    height: maxHeight,
                    "--readonly-visible-rows":
                        visibleRows
                }}
            >
                <div className="readonly-table-main">
                    <div
                        className={[
                            "readonly-table-wrapper",
                            !hasItems
                                ? "readonly-table-wrapper-empty"
                                : ""
                        ]
                            .filter(Boolean)
                            .join(" ")}
                    >
                        {!hasItems ? (
                            this.renderEmptyState()
                        ) : (
                            <table className="readonly-table">
                                {this.renderTableHeader(
                                    headers
                                )}

                                {this.renderTableBody(
                                    headers,
                                    paginatedItems,
                                    rowKey,
                                    startIndex
                                )}
                            </table>
                        )}
                    </div>

                    {hasItems && (
                        <UITablePagination
                            currentPage={currentPage}
                            itemsPerPage={itemsPerPage}
                            totalPages={totalPages}
                            totalItems={totalItems}
                            onPageChange={this.changePage}
                            onItemsPerPageChange={this.handleItemsPerPageChange}
                        />
                    )}
                </div>
            </div>
        );
    }
}
export class UIOrderDetails extends React.Component {
    constructor(props) {
        super(props);

        this.le = Languages.Components.UIOrderDetails[Languages.selectedLanguage];
    }

    componentDidMount() {
        document.addEventListener(
            "keydown",
            this.handleKeyDown
        );
    }

    componentWillUnmount() {
        document.removeEventListener(
            "keydown",
            this.handleKeyDown
        );
    }

    handleKeyDown = event => {
        if (event.key === "Escape") {
            this.handleClose();
        }
    };

    handleClose = () => {
        const {
            onClose
        } = this.props;

        if (typeof onClose === "function") {
            onClose();
        }
    };

    handleOverlayClick = event => {
        if (event.target === event.currentTarget) {
            this.handleClose();
        }
    };

    mapProduct = item => {
        return {
            lineNumber: item?.lineNumber,
            sku: item?.sku,
            description: item?.description,
            quantity: item?.quantity,
            serial: item?.lot,
            amount: item?.amnt
        };
    };

    getItemValue = value => {
        if (value === null || value === undefined || value === "") {
            return this.le.notAvailable;
        }

        return value;
    };

    getRowKey = (item, index) => {
        const product = this.mapProduct(item);

        return [
            product.lineNumber || "NO_LINE",
            product.sku || "NO_SKU",
            product.serial || "NO_SERIAL",
            index
        ].join("-");
    };

    renderLoadingState = () => {
        return (
            <div className="order-details-modal-state">
                <div className="order-details-modal-loader">
                    <i
                        className="fa-solid fa-spinner fa-spin"
                        aria-hidden="true"
                    />
                </div>

                <div className="order-details-modal-state-title">
                    {this.le.loading}
                </div>
            </div>
        );
    };

    renderErrorState = () => {
        const {
            error,
            onRetry
        } = this.props;

        return (
            <div className="order-details-modal-state">
                <div className="order-details-modal-error-icon">
                    <i
                        className="fa-solid fa-circle-exclamation"
                        aria-hidden="true"
                    />
                </div>

                <div className="order-details-modal-state-title">
                    {error}
                </div>

                {typeof onRetry === "function" && (
                    <button
                        type="button"
                        className="order-details-retry-button"
                        onClick={onRetry}
                    >
                        <i
                            className="fa-solid fa-rotate-right"
                            aria-hidden="true"
                        />

                        <span>
                            {this.le.retry}
                        </span>
                    </button>
                )}
            </div>
        );
    };

    renderEmptyState = () => {
        return (
            <div className="order-details-modal-state">
                <div className="order-details-modal-empty-icon">
                    <i
                        className="fa-solid fa-box-open"
                        aria-hidden="true"
                    />
                </div>

                <div className="order-details-modal-state-title">
                    {this.le.empty}
                </div>
            </div>
        );
    };

    renderProductRow = (item, index) => {
        const product = this.mapProduct(item);

        return (
            <tr
                key={this.getRowKey(
                    item,
                    index
                )}
            >
                <td className="order-detail-sku">
                    <span className="order-detail-sku-value">
                        {this.getItemValue(
                            product.sku
                        )}
                    </span>
                </td>

                <td className="order-detail-description">
                    {this.getItemValue(
                        product.description
                    )}
                </td>

                <td className="order-detail-quantity">
                    <span className="order-detail-quantity-badge">
                        {this.getItemValue(
                            product.quantity
                        )}
                    </span>
                </td>

                <td className="order-detail-serial">
                    {this.getItemValue(
                        product.serial
                    )}
                </td>

                {this.props.showAmount === true && (
                    <td className="order-detail-amount cell-center">
                        {this.getItemValue(product.amount)}
                    </td>
                )}

            </tr>
        );
    };

    renderContent = () => {
        const {
            items = [],
            loading = false,
            error = null
        } = this.props;

        if (loading) {
            return this.renderLoadingState();
        }

        if (error) {
            return this.renderErrorState();
        }

        if (!Array.isArray(items) || items.length === 0) {
            return this.renderEmptyState();
        }

        return (
            <div className="order-details-table-wrapper">
                <table className="order-details-table">
                    <thead>
                        <tr>
                            <th className="order-detail-sku">
                                {this.le.sku}
                            </th>

                            <th className="order-detail-description">
                                {this.le.description}
                            </th>

                            <th className="order-detail-quantity">
                                {this.le.quantity}
                            </th>

                            <th className="order-detail-serial">
                                {this.le.serial}
                            </th>

                            {this.props.showAmount === true && (
                                <th className="order-detail-amount cell-center">
                                    Amount
                                </th>
                            )}

                        </tr>
                    </thead>

                    <tbody>
                        {items.map(
                            this.renderProductRow
                        )}
                    </tbody>
                </table>
            </div>
        );
    };

    render() {
        const {
            items = [],
            loading = false,
            error = null,
            orderNumber
        } = this.props;

        const itemCount =
            Array.isArray(items)
                ? items.length
                : 0;

        const showCount =
            !loading &&
            !error;

        return (
            <div
                className="order-details-modal-overlay"
                role="presentation"
                onMouseDown={
                    this.handleOverlayClick
                }
            >
                <div
                    className="order-details-modal"
                    role="dialog"
                    aria-modal="true"
                    aria-labelledby="order-details-modal-title"
                >
                    <div className="order-details-modal-header">
                        <div className="order-details-modal-heading">
                            <div className="order-details-modal-icon">
                                <i
                                    className="fa-solid fa-clipboard-list"
                                    aria-hidden="true"
                                />
                            </div>

                            <div className="order-details-modal-heading-text">
                                <div
                                    id="order-details-modal-title"
                                    className="order-details-modal-title"
                                >
                                    {this.le.title}
                                </div>

                                {orderNumber && (
                                    <div className="order-details-modal-subtitle">
                                        {orderNumber}
                                    </div>
                                )}
                            </div>

                            {showCount && (
                                <span
                                    className="order-details-count"
                                    aria-label={this.le.productCount}
                                    title={this.le.productCount}
                                >
                                    {itemCount}
                                </span>
                            )}
                        </div>

                        <button
                            type="button"
                            className="order-details-modal-close"
                            aria-label={this.le.close}
                            title={this.le.close}
                            onClick={this.handleClose}
                        >
                            <i
                                className="fa-solid fa-xmark"
                                aria-hidden="true"
                            />
                        </button>
                    </div>

                    <div className="order-details-modal-body">
                        {this.renderContent()}
                    </div>
                </div>
            </div>
        );
    }
}
export class UIActionButton extends React.Component {
    handleClick = event => {
        const {
            loading = false,
            disabled = false,
            onClick
        } = this.props;

        event.preventDefault();
        event.stopPropagation();

        if (
            loading ||
            disabled ||
            typeof onClick !== "function"
        ) {
            return;
        }

        onClick(event);
    };

    render() {
        const {
            icon,
            label,
            danger = false,
            loading = false,
            disabled = false,
            active = false,
            ariaExpanded
        } = this.props;

        const buttonClassName = [
            "ui-action-button",
            danger
                ? "ui-action-button-danger"
                : "ui-action-button-default",
            active && !danger
                ? "ui-action-button-active"
                : ""
        ]
            .filter(Boolean)
            .join(" ");

        return (
            <button
                type="button"
                className={buttonClassName}
                title={label}
                aria-label={label}
                aria-expanded={
                    typeof ariaExpanded === "boolean"
                        ? ariaExpanded
                        : undefined
                }
                disabled={disabled || loading}
                onClick={this.handleClick}
            >
                <i
                    className={
                        loading
                            ? "fa-solid fa-spinner fa-spin"
                            : icon
                    }
                    aria-hidden="true"
                />

                <span className="ui-action-tooltip">
                    {label}
                </span>
            </button>
        );
    }
}
export class UIResponsePopup extends React.Component {
    constructor(props) {
        super(props);

        this.closeButtonRef =
            React.createRef();

        this.previousBodyOverflow = "";
    }

    componentDidMount() {
        document.addEventListener(
            "keydown",
            this.handleKeyDown
        );

        this.previousBodyOverflow =
            document.body.style.overflow;

        document.body.style.overflow =
            "hidden";

        if (this.closeButtonRef.current) {
            this.closeButtonRef.current.focus();
        }
    }

    componentWillUnmount() {
        document.removeEventListener(
            "keydown",
            this.handleKeyDown
        );

        document.body.style.overflow =
            this.previousBodyOverflow;
    }

    handleKeyDown = event => {
        if (
            event.key === "Escape" &&
            typeof this.props.onClose ===
            "function"
        ) {
            event.preventDefault();

            this.props.onClose();
        }
    };

    handleOverlayClick = event => {
        if (
            event.target ===
            event.currentTarget &&
            typeof this.props.onClose ===
            "function"
        ) {
            this.props.onClose();
        }
    };

    render() {
        const {
            accepted,
            title,
            message,
            closeText,
            onClose
        } = this.props;

        const popupClassName = accepted
            ? "ui-response-popup ui-response-popup--accepted"
            : "ui-response-popup ui-response-popup--rejected";

        const iconClassName = accepted
            ? "fa-solid fa-check"
            : "fa-solid fa-xmark";

        return (
            <div
                className="ui-response-popup-overlay"
                role="presentation"
                onMouseDown={
                    this.handleOverlayClick
                }
            >
                <div
                    className={popupClassName}
                    role="dialog"
                    aria-modal="true"
                    aria-labelledby="ui-response-popup-title"
                    aria-describedby="ui-response-popup-message"
                    onMouseDown={event =>
                        event.stopPropagation()
                    }
                >
                    <div className="ui-response-popup-status">
                        <div className="ui-response-popup-icon">
                            <i
                                className={
                                    iconClassName
                                }
                                aria-hidden="true"
                            />
                        </div>
                    </div>

                    <div className="ui-response-popup-content">
                        <h2
                            id="ui-response-popup-title"
                            className="ui-response-popup-title"
                        >
                            {title}
                        </h2>

                        {message && (
                            <p
                                id="ui-response-popup-message"
                                className="ui-response-popup-message"
                            >
                                {message}
                            </p>
                        )}
                    </div>

                    <div className="ui-response-popup-actions">
                        <button
                            ref={
                                this.closeButtonRef
                            }
                            type="button"
                            className="ui-response-popup-button"
                            onClick={onClose}
                        >
                            {closeText}
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}
export class UIConfirmPopup extends React.Component {
    constructor(props) {
        super(props);

        this.confirmButtonRef = React.createRef();
        this.previousBodyOverflow = "";
    }

    componentDidMount() {
        document.addEventListener("keydown", this.handleKeyDown);

        this.previousBodyOverflow = document.body.style.overflow;
        document.body.style.overflow = "hidden";

        if (this.props.autoFocusConfirm && this.confirmButtonRef.current) {
            this.confirmButtonRef.current.focus();
        }
    }

    componentWillUnmount() {
        document.removeEventListener("keydown", this.handleKeyDown);

        document.body.style.overflow = this.previousBodyOverflow;
    }

    handleKeyDown = event => {
        const {
            closeOnEscape,
            loading,
            onCancel
        } = this.props;

        if (
            event.key === "Escape" &&
            closeOnEscape &&
            !loading &&
            typeof onCancel === "function"
        ) {
            event.preventDefault();
            onCancel();
        }
    };

    handleOverlayClick = event => {
        const {
            closeOnOverlay,
            loading,
            onCancel
        } = this.props;

        const clickedOverlay = event.target === event.currentTarget;

        if (
            clickedOverlay &&
            closeOnOverlay &&
            !loading &&
            typeof onCancel === "function"
        ) {
            onCancel();
        }
    };

    handleConfirm = () => {
        const {
            loading,
            onConfirm
        } = this.props;

        if (loading || typeof onConfirm !== "function") {
            return;
        }

        onConfirm();
    };

    handleCancel = () => {
        const {
            loading,
            onCancel
        } = this.props;

        if (loading || typeof onCancel !== "function") {
            return;
        }

        onCancel();
    };

    getVariant = () => {
        const {
            danger,
            warning
        } = this.props;

        if (danger) {
            return "danger";
        }

        if (warning) {
            return "warning";
        }

        return "primary";
    };

    render() {
        const {
            title,
            message,
            highlightedValue,
            confirmText,
            cancelText,
            icon,
            loading,
            loadingText,
            showCancelButton
        } = this.props;

        const variant = this.getVariant();

        const confirmLabel =
            loading && loadingText
                ? loadingText
                : confirmText;

        return (
            <div
                className="ui-confirm-popup-overlay"
                onMouseDown={this.handleOverlayClick}
                role="presentation"
            >
                <div
                    className={`ui-confirm-popup ${variant}`}
                    role="alertdialog"
                    aria-modal="true"
                    aria-labelledby="ui-confirm-popup-title"
                    aria-describedby="ui-confirm-popup-description"
                    aria-busy={loading}
                    onMouseDown={event => event.stopPropagation()}
                >
                    <div
                        className={`ui-confirm-popup-icon ${variant}`}
                        aria-hidden="true"
                    >
                        <i className={icon} />
                    </div>

                    <div className="ui-confirm-popup-content">
                        <h2
                            id="ui-confirm-popup-title"
                            className="ui-confirm-popup-title"
                        >
                            {title}
                        </h2>

                        {message && (
                            <p
                                id="ui-confirm-popup-description"
                                className="ui-confirm-popup-message"
                            >
                                {message}
                            </p>
                        )}

                        {highlightedValue && (
                            <div
                                className={`ui-confirm-popup-highlighted-value ${variant}`}
                                title={highlightedValue}
                            >
                                {highlightedValue}
                            </div>
                        )}
                    </div>

                    <div className="ui-confirm-popup-actions">
                        {showCancelButton && (
                            <button
                                type="button"
                                className="ui-confirm-popup-button secondary"
                                disabled={loading}
                                onClick={this.handleCancel}
                            >
                                {cancelText}
                            </button>
                        )}

                        <button
                            ref={this.confirmButtonRef}
                            type="button"
                            className={`ui-confirm-popup-button ${variant}`}
                            disabled={loading}
                            onClick={this.handleConfirm}
                        >
                            {loading && (
                                <i
                                    className="fa-solid fa-spinner fa-spin"
                                    aria-hidden="true"
                                />
                            )}

                            <span>{confirmLabel}</span>
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}
export class UISuccessPopup extends React.Component {
    constructor(props) {
        super(props);

        this.closeTimer = null;
    }

    componentDidMount() {
        if (this.props.visible) {
            this.startAutoCloseTimer();
        }
    }

    componentDidUpdate(prevProps) {
        const {
            visible,
            autoClose = true,
            duration = 3500
        } = this.props;

        if (!prevProps.visible && visible) {
            this.startAutoCloseTimer();
        }

        if (prevProps.visible && !visible) {
            this.clearAutoCloseTimer();
        }

        if (
            visible &&
            (
                prevProps.duration !== duration ||
                prevProps.autoClose !== autoClose
            )
        ) {
            this.startAutoCloseTimer();
        }
    }

    componentWillUnmount() {
        this.clearAutoCloseTimer();
    }

    startAutoCloseTimer = () => {
        const {
            autoClose = true,
            duration = 3500,
            onClose
        } = this.props;

        this.clearAutoCloseTimer();

        if (!autoClose || !onClose) {
            return;
        }

        this.closeTimer = setTimeout(() => {
            onClose();
        }, duration);
    };

    clearAutoCloseTimer = () => {
        if (this.closeTimer) {
            clearTimeout(this.closeTimer);
            this.closeTimer = null;
        }
    };

    handleClose = () => {
        this.clearAutoCloseTimer();

        if (this.props.onClose) {
            this.props.onClose();
        }
    };

    hasHighlightedValue = () => {
        const { highlightedValue } = this.props;

        return (
            highlightedValue !== undefined &&
            highlightedValue !== null &&
            highlightedValue !== ""
        );
    };

    renderMessage = () => {
        const {
            message,
            highlightedValue,
            messageSuffix
        } = this.props;

        const hasValue = this.hasHighlightedValue();

        if (!message && !hasValue && !messageSuffix) {
            return null;
        }

        return (
            <div className="success-popup-message">
                {message && (
                    <span className="success-popup-message-text">
                        {message}
                    </span>
                )}

                {hasValue && (
                    <span
                        className="success-popup-highlighted-value"
                        title={String(highlightedValue)}
                    >
                        {highlightedValue}
                    </span>
                )}

                {messageSuffix && (
                    <span className="success-popup-message-text">
                        {messageSuffix}
                    </span>
                )}
            </div>
        );
    };

    render() {
        const {
            visible,
            title,
            iconClassName = "fa-solid fa-check",
            duration = 3500,
            autoClose = true,
            showProgress = true,
            closeLabel = "Chiudi"
        } = this.props;

        if (!visible) {
            return null;
        }

        return (
            <div
                className="success-popup"
                role="status"
                aria-live="polite"
                aria-atomic="true"
                style={{
                    "--success-popup-duration": `${duration}ms`
                }}
            >
                <button
                    className="success-popup-close"
                    type="button"
                    onClick={this.handleClose}
                    aria-label={closeLabel}
                >
                    <i
                        className="fa-solid fa-xmark"
                        aria-hidden="true"
                    />
                </button>

                <div className="success-popup-content">
                    <div
                        className="success-popup-icon"
                        aria-hidden="true"
                    >
                        <i className={iconClassName} />
                    </div>

                    <div className="success-popup-body">
                        {title && (
                            <div className="success-popup-title">
                                {title}
                            </div>
                        )}

                        {this.renderMessage()}
                    </div>
                </div>

                {autoClose && showProgress && (
                    <div
                        className="success-popup-progress"
                        aria-hidden="true"
                    />
                )}
            </div>
        );
    }
}
export class UIOrderInfoSection extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            referenceFocused: false
        };
    }

    render() {
        const data = this.props.data || {};
        const values = this.props.values || {};
        const errors = this.props.errors || {};

        return (
            <div className="widget order-info-widget">
                <div className="widget-header">{data.title}</div>

                <div className="widget-content order-info-content">
                    <div className="order-info-field reference-field">
                        <div className="input-label">
                            {data.referenceLabel}
                            {data.referenceMandatory && (
                                <span className="mandatory">*</span>
                            )}
                        </div>
                        <div className="input-field">
                            <input
                                type="text"
                                name="orderReference"
                                value={values.orderReference || ""}
                                maxLength={data.referenceMaxLength || 100}
                                placeholder={data.referencePlaceholder || ""}
                                onChange={this.props.onChange}
                                onFocus={() =>this.setState({ referenceFocused: true })}
                                onBlur={() =>this.setState({ referenceFocused: false })}
                                className={
                                    errors?.orderReference
                                        ? "input-validation-error"
                                        : ""
                                }
                            />
                            {this.state.referenceFocused && data.referenceHint && (
                                <div className="input-hint">
                                    {data.referenceHint}
                                </div>
                            )}
                        </div>
                    </div>

                    <div className="order-info-field notes-field">
                        <div className="input-label">
                            {data.notesLabel}
                            {data.notesMandatory && (
                                <span className="mandatory">*</span>
                            )}
                        </div>
                        <div className="input-field">
                            <textarea
                                name="notes"
                                value={values.notes || ""}
                                maxLength={data.notesMaxLength || 1000}
                                rows={data.notesRows || 5}
                                placeholder={data.notesPlaceholder || ""}
                                onChange={this.props.onChange}
                                className={
                                    errors?.notes
                                        ? "input-validation-error"
                                        : ""
                                }
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export class UIInputGroup extends React.Component {
    render() {
        const {
            label,
            hint,
            leftName,
            leftValue,
            leftOptions = [],
            rightName,
            rightValue,
            rightType = "text",
            onChange,
            className,
            error,
            mandatory,
            disabled,
            readOnly
        } = this.props;

        return (
            <div className={"input-group ui-input-group " + (className || "")}>
                <div className={"input-element " + (mandatory ? "mandatory " : "")}>

                    {label &&
                        <label className="input-label ellipsis">
                            {label}
                        </label>
                    }

                    <div className={"input-field " + (error ? "input-field-error" : "")}>

                        <div className="ui-input-group-control">

                            <select
                                className="ui-input-group-select"
                                name={leftName || ""}
                                value={leftValue || ""}
                                onChange={onChange}
                                disabled={disabled || readOnly}
                            >
                                {leftOptions.map(option => (
                                    <option
                                        key={option.value}
                                        value={option.value}>
                                        {option.text}
                                    </option>
                                ))}
                            </select>

                            <input
                                className="ui-input-group-input"
                                type={rightType}
                                name={rightName || ""}
                                value={rightValue || ""}
                                placeholder={hint || ""}
                                onChange={onChange}
                                disabled={disabled || readOnly}
                            />

                        </div>

                    </div>

                </div>
            </div>
        );
    }
}

export class CurrentPasswordPopup extends React.Component {

    constructor(props) {
        super(props);

        this.le = Languages.Components.CurrentPasswordPopup[ Languages.selectedLanguage];

        this.state = {
            currentPassword: "",
            error: ""
        };
    }

    confirm = () => {
        const currentPassword = this.state.currentPassword;

        if (!currentPassword) {
            this.setState({
                error: this.le.requiredError
            });
            return;
        }

        this.props.onConfirm(currentPassword);
    };

    keyUp = event => {
        if (event.key === "Enter" && !this.props.loading) {
            this.confirm();
        }
    };

    render() {
        return (
            <UIPopup
                className={"current-password-popup" + (this.props.loading ? " is-loading" : "")}
                title={this.props.title || this.le.defaultTitle}
                onCancel={this.props.onCancel}
                buttons={[
                    <>
                        <UIButton
                            text={this.le.cancel}
                            disabled={this.props.loading}
                            onClick={this.props.onCancel}
                        />

                        <UIButton
                            className="confirm"
                            text={
                                this.props.loading
                                    ? this.le.confirming
                                    : this.le.confirm
                            }
                            disabled={this.props.loading}
                            onClick={this.confirm}
                        />
                    </>
                ]}
            >
                <p className="current-password-popup-message">
                    {this.props.message || this.le.defaultMessage}
                </p>

                <UIInput
                    type="password"
                    name="currentPassword"
                    label={this.le.currentPassword}
                    value={this.state.currentPassword}
                    maxLength={64}
                    error={!!this.state.error}
                    onKeyUp={this.keyUp}
                    onChange={event =>
                        this.setState({
                            currentPassword: event.target.value,
                            error: ""
                        })
                    }
                />

                {this.state.error &&
                    <div
                        className="login-error"
                        role="alert"
                    >
                        {this.state.error}
                    </div>
                }
            </UIPopup>
        );
    }
}

export class PasswordPolicyTooltip extends React.Component {
    constructor(props) {
        super(props);

        this.le = Languages.Components.PasswordSecurity[Languages.selectedLanguage];
    }

    renderRule = (valid, text, hasInput) =>
    {
        const status = valid
            ? "valid"
            : hasInput
                ? "invalid"
                : "pending";

        const iconClassName = valid
            ? "fa-solid fa-circle-check"
            : hasInput
                ? "fa-solid fa-circle-xmark"
                : "fa-regular fa-circle";

        const statusText = valid
            ? this.le.requirementValid
            : hasInput
                ? this.le.requirementInvalid
                : this.le.requirementPending;

        return (
            <li
                className={"password-rule " + status}
                aria-label={text + ": " + statusText}
            >
                <i
                    className={"password-rule-icon " + iconClassName}
                    aria-hidden="true"
                />

                <span className="password-rule-text">
                    {text}
                </span>
            </li>
        );
    };

    render() {
        const password = this.props.password || "";

        const checks = evaluatePassword(password);

        const hasInput = password.length > 0;

        const tooltipId = this.props.id || "password-policy-tooltip";

        return (
            <div
                id={tooltipId}
                className="password-policy-tooltip"
                role="status"
                aria-live="polite"
            >
                <div className="password-policy-title">
                    {this.le.policyTitle}
                </div>

                <ul className="password-rules">
                    {this.renderRule(checks.length, this.le.length, hasInput )}

                    {this.renderRule(checks.uppercase, this.le.uppercase, hasInput)}

                    {this.renderRule(checks.lowercase, this.le.lowercase, hasInput)}

                    {this.renderRule(checks.number, this.le.number, hasInput)}

                    {this.renderRule(checks.special, this.le.special, hasInput)}
                </ul>

                {checks.edgeSpaces && (
                    <small className="password-space-warning">
                        <i
                            className={"fa-solid fa-triangle-exclamation"}
                            aria-hidden="true"
                        />

                        <span>
                            {this.le.edgeSpaces}
                        </span>
                    </small>
                )}
            </div>
        );
    }
}